import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppConstatnt, CREDIT_CARD } from "../../Utils/AppConstant";
import { useHistory } from 'react-router';
import { useDispatch } from "react-redux";
import { clearTransaction } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';
import { getRecentTruckPayment, setRecentTruckPayment } from '../../Utils/Utility'

function TransactionDialog({ intl, transactionId, open = false, id, message, paymentType, amount, statusMessage, selection, remainingAmount, total_bill_amount, load_control_num }) {
    const [show, setShow] = useState(open);
    const [counter, setCounter] = useState(6);
    const history = useHistory();
    const dispatch = useDispatch();
    const { formatMessage } = intl;

    const handleClose = () => setShow(false);


    useEffect(() => {
        const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

        return () => clearInterval(timer)
    }, [counter])

    useEffect(() => {
        if (counter == 0) {
            redirection();
        }
    }, [counter])

    const handleChange = (e) => {
        redirection();
    }

    function redirection() {
        if(load_control_num){
        const recentPayment = getRecentTruckPayment()
        const recentPaymentObj = {
            load_control_num,
            selection
        }
       setRecentTruckPayment([...recentPayment, recentPaymentObj])
        }  
        
        if (paymentType === AppConstatnt.CHECK_PAY) {
            history.push({ pathname: '/' });
        }
        else {
            history.push({ pathname: `/paymentcompleted/${id}`, state: { transactionId, amount, id, selection, remainingAmount, total_bill_amount } });
        }
        dispatch(clearTransaction());
    }

    return (
        <React.Fragment>
            <Modal
                className="fade contest_input_modal"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <Modal.Dialog className="modal-dialog-centered modal-our">
                    <Modal.Body className="text-center">
                        <h4 className="text-success mb-3">{formatMessage({ id: "app.transaction_success" })}</h4>
                        {paymentType === AppConstatnt.CREDIT_CARD &&
                            <p>{formatMessage({ id: "app.reference_number" })} <br />
                                {transactionId}</p>
                        }

                        <p>{formatMessage({ id: "app.transaction_success_content" })}</p>
                    </Modal.Body>
                    <Modal.Footer className="border-0 justify-content-center pb-5">
                        <button type="button" className="btn justify-content-center" style={{ minWidth: '100px' }} onClick={handleChange}>{message}
                            <strong className="remaining_amt" className="ml-2"><u>{formatMessage({ id: "app.click_here" })}</u></strong></button>
                    </Modal.Footer>
                </Modal.Dialog>

            </Modal>
        </React.Fragment>
    )
}

export default injectIntl(TransactionDialog);
